import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id AF03DF0A-3E57-412D-B72E-67938C4FD599
 * name cellphone-arrow-down-variant
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-arrow-down-variant.svg
 * tags
 * - Cellphone / Phone 
 */
export const CellphoneArrowDownVariantIcon = createSvgIcon(<><path d="M18 14L23 9L21.6 7.6L19 10.2V3H17V10.2L14.4 7.6L13 9L18 14M19 16V21C19 22.1 18.1 23 17 23H7C5.9 23 5 22.1 5 21V3C5 1.9 5.9 1 7 1H14V5H7V19H17V16H19Z" /></>, 'CellphoneArrowDownVariantIcon');
export default CellphoneArrowDownVariantIcon